import React from 'react'
import { NavLink as Link } from 'react-router-dom'

class HomeComponenteDestaqueModeloCardGrafico extends React.Component {
    render() {
        return <>{this.renderServico(this.props.conteudo)}</>
    }

    renderServico(conteudo) {
        if (conteudo) {
            switch (conteudo.tipo) {
                case 'serviço':
                    var backGroudStyle = {
                        backgroundImage: `url("data:image/jpeg;base64,${conteudo.imagemByte}")`,
                    }

                    return (
                        <div className="HomeDestaqueCardGrafico">
                            <div className="HomeDestaqueCardGraficoItens">
                                <p className="homeDestaqueModeloCardGraficoTitulo1">{conteudo.tituloSuperior}</p>

                                {conteudo.url && conteudo.url.includes('http') ? (
                                    <a className="homeDestaqueModeloCardGraficoTitulo2" href={conteudo.url} target="blank">
                                        {conteudo.tituloMenu}
                                    </a>
                                ) : (
                                    <Link className="homeDestaqueModeloCardGraficoTitulo2" to={conteudo.url} title={conteudo.tituloMenu}>
                                        {conteudo.tituloMenu}
                                    </Link>
                                )}
                            </div>
                            <div style={backGroudStyle} className="homeDestaqueImagemDeFundoCard homeDestaqueCardImagem"></div>
                        </div>
                    )

                case 'atalho':
                    return (
                        <div className="HomeDestaqueCardGrafico">
                            <div className="homeDestaqueImagemDeFundoCard"></div>
                            <div>
                                <a href={conteudo.url} target="blank">
                                    {conteudo.tituloMenu}
                                </a>
                            </div>
                        </div>
                    )

                case 'conteudo':
                    let params = {
                        conteudo: conteudo.conteudo,
                        titulo: conteudo.tituloMenu,
                    }

                    var backGroudStyle = {
                        backgroundImage: `url("data:image/jpeg;base64,${conteudo.imagemByte}")`,
                    }

                    return (
                        <div className="HomeDestaqueCardGrafico">
                            <div>
                                <p className="homeDestaqueModeloCardGraficoTitulo1">{conteudo.tituloSuperior}</p>
                                <p className="homeDestaqueModeloCardGraficoTitulo2">{conteudo.tituloMenu}</p>
                                <Link
                                    className="botaoAreaDestaque"
                                    to={'/conteudoGrupo/' + btoa(encodeURIComponent(JSON.stringify(params)))}
                                    title={conteudo.tituloMenu}
                                >
                                    ACESSE
                                </Link>
                            </div>
                            <div style={backGroudStyle} className="homeDestaqueImagemDeFundoCard homeDestaqueCardImagem"></div>
                        </div>
                    )

                default:
                    return <div className="homeDestaqueImagemDeFundoCard">{conteudo.tituloMenu} </div>
            }
        }
    }
}

export default HomeComponenteDestaqueModeloCardGrafico
